import { lazyWithRetry } from "../../utils/chunkLoadRecovery";

export const PaymentSetupPage = lazyWithRetry(() => import("./PaymentSetup"));
export const FeeHeadsManagementPage = lazyWithRetry(() => import("./FeeHeadsManagement"));
export const FeeStructureManagementPage = lazyWithRetry(() => import("./FeeStructureManagement"));
export const StudentFeesManagementPage = lazyWithRetry(() => import("./StudentFeesManagement"));
export const FeeCollectionPage = lazyWithRetry(() => import("./FeeCollection"));
export const FeeReportsPage = lazyWithRetry(() => import("./FeeReports"));
export const InstituteFeeSettingsPage = lazyWithRetry(() => import("./FeeSettings"));
export const StudentFeeDashboardPage = lazyWithRetry(() => import("./StudentFeeDashboard"));
